import React, { useCallback, useMemo } from 'react';
import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { useMessages } from 'modules/intl';
import {
  NOTES_GROUP_BY_TYPE,
  NotesFilterContextValue,
  useNotesFilterContext
} from './NotesFilterContextProvider';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: theme.spacing(16)
  },
  selector: {
    margin: theme.spacing(1, 2, 1, 2)
  },
  selectorTitle: {
    color: `${theme.palette.text.secondary}`,
    whiteSpace: 'nowrap'
  }
}));

const useSelectStyles = makeStyles((theme) => ({
  outlined: {
    padding: theme.spacing(1)
  }
}));

const messageIds = ['notesGroupBySelector.none', 'notesGroupBySelector.labels'];
export const NotesGroupBySelector: React.FC = () => {
  const classes = useStyles();
  const selectStyles = useSelectStyles();
  const { filterContext, setFilterContext } = useNotesFilterContext();

  const messages = useMessages(messageIds);

  const viewOptions = useMemo(
    () => [
      {
        value: NOTES_GROUP_BY_TYPE.NONE,
        text: messages['notesGroupBySelector.none']
      },
      {
        value: NOTES_GROUP_BY_TYPE.LABELS,
        text: messages['notesGroupBySelector.labels']
      }
    ],
    [messages]
  );

  const handleChange = useCallback(
    (event) => {
      setFilterContext((previous: NotesFilterContextValue) => ({
        ...previous,
        groupBy: event.target.value as NOTES_GROUP_BY_TYPE
      }));
    },
    [setFilterContext]
  );

  return (
    <>
      <Typography variant={'subtitle2'} className={classes.selectorTitle}>
        <FormattedMessage id="notesGroupBySelector.title" />
      </Typography>
      <Box
        component="span"
        className={classes.root}
        data-testid="notes-group-by-selector-wrapper"
      >
        <FormControl variant="outlined" className={classes.root}>
          <Select
            classes={selectStyles}
            data-testid="notes-group-by-selector"
            value={filterContext.groupBy}
            onChange={handleChange}
            className={classes.selector}
          >
            {viewOptions.map(({ value, text }) => {
              return (
                <MenuItem
                  key={value}
                  value={value}
                  data-testid={`notes-group-by-option_${value}`}
                >
                  {text}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
    </>
  );
};
